var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgIconClearPlateRegsitration = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 34,
    viewBox: "0 0 32 34",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.83333 0C1.26853 0 0 1.26853 0 2.83333V11H3V4C3 3.2176 3.2176 3 4 3H9V0H2.83333ZM23 0V3H28C28.7824 3 29 3.2176 29 4V11H32V3C32 1.43519 30.5648 0 29 0H23ZM29 23H32V31C32 32.5648 30.5648 34 29 34H23V31H28C28.7824 31 29 30.7824 29 30V23ZM9 34V31H4C3.2176 31 3 30.7824 3 30V23H0V31C0 32.5648 1.43519 34 3 34H9ZM16.5 26.5C22.0228 26.5 26.5 22.0228 26.5 16.5C26.5 10.9772 22.0228 6.5 16.5 6.5C10.9772 6.5 6.5 10.9772 6.5 16.5C6.5 22.0228 10.9772 26.5 16.5 26.5ZM16.5 28C22.8513 28 28 22.8513 28 16.5C28 10.1487 22.8513 5 16.5 5C10.1487 5 5 10.1487 5 16.5C5 22.8513 10.1487 28 16.5 28ZM20.35 22L16.5 18.15L12.65 22L11 20.35L14.85 16.5L11 12.65L12.65 11L16.5 14.85L20.35 11L22 12.65L18.15 16.5L22 20.35L20.35 22Z",
    fill: "#414042"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconClearPlateRegsitration, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/IconClearPlateRegsitration.3ff0bc52.svg";
export { ForwardRef as ReactComponent };